/** @module SiteAdmin/New3DMaterial **/
define([
	"dojo/_base/declare",
	"./_New3DMixin"
], function(declare, _New3DMixin) {

	return declare(_New3DMixin, {
		threeDOperation: "Create3DMaterial"
	});
});